import React from 'react';
import DataGrid from '../../DataGrid/DataGrid';

import { PaginationMode } from '../../DataGrid/types';
import { useTranslation } from 'react-i18next';
import { WiFiEntityTransformer } from '../../../utils/transformers';
import { useStyles } from './DataService.utils';
import { CallHistory } from '../../../store/types/CallHistory';
import { generateColumns, WiFiTableRowInterface } from './WiFi.utils';
import { TransactionTableInterface } from '../utils';

const WiFi: React.VFC<TransactionTableInterface> = ({
    currency,
    data,
    onPageChange,
    onPageSizeChange,
    initialPageSize,
    loading,
    rowCount,
    userDateTimeFormat,
}) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const columns = generateColumns(t, currency, userDateTimeFormat);

    const items: WiFiTableRowInterface[] = data.map((item: CallHistory) =>
        WiFiEntityTransformer(item),
    );

    return (
        <DataGrid<WiFiTableRowInterface>
            data={items}
            dataQa={'WiFi-table'}
            loading={loading}
            columns={columns}
            rowCount={rowCount}
            paginationMode={PaginationMode.Server}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
            initialPageSize={initialPageSize}
            classes={{
                header: classes.header,
                tableContainer: classes.tableContent,
            }}
        />
    );
};

export default WiFi;
